function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { attachSubComponents, DefaultsProvider, separateChildrenByType } from '../../util';
import { AccordionSectionText, StyledLeadingTrailing } from './elements';
import { Text } from '../Text';
const LeadingTrailing = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(StyledLeadingTrailing, props, /*#__PURE__*/React.createElement(DefaultsProvider, {
  value: {
    iconSize: 'large'
  }
}, children));
const Leading = props => /*#__PURE__*/React.createElement(LeadingTrailing, props);
const Trailing = props => /*#__PURE__*/React.createElement(LeadingTrailing, props);
const Number = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Text, _extends({
  size: 2,
  weight: "heavy"
}, props), children);
const Heading = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Text, _extends({
  size: 2,
  weight: "heavy"
}, props), children);
const SupportiveText = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Text, _extends({
  size: 1,
  color: "var(--aui-on-surface-soft)"
}, props), children);
export const Header = attachSubComponents('Header', ({
  children
}) => {
  const [leading, trailing, content] = separateChildrenByType(children, Leading, Trailing);
  return /*#__PURE__*/React.createElement(React.Fragment, null, leading, /*#__PURE__*/React.createElement(AccordionSectionText, null, content), trailing);
}, {
  Heading,
  Leading,
  Number,
  SupportiveText,
  Trailing
});